import { useContext } from "react";
import MyContext from "../../context/Context";
import { doc, updateDoc } from "firebase/firestore";
import { fireDB } from "../../firebase/FirebaseConfig";
import toast from "react-hot-toast";
import {
  collection,
  query,
  where,
  getDocs,

} from "firebase/firestore";

const UserDetails = () => {
    const context = useContext(MyContext);
    const { getAllUser } = context;



const handleRoleChange = async (uid, newRole) => {
  try {
    const q = query(
      collection(fireDB, "user"), // 🔥 correct collection name
      where("uid", "==", uid)
    );

    const querySnapshot = await getDocs(q);

    if (querySnapshot.empty) {
      toast.error("User document not found");
      return;
    }

    querySnapshot.forEach(async (docSnap) => {
      await updateDoc(doc(fireDB, "user", docSnap.id), {
        role: newRole,
      });
    });

    toast.success("Role updated successfully");
  } catch (error) {
    console.error(error);
    toast.error("Failed to update role");
  }
};



    return (
        <div>
            <div>
                <div className="py-5 flex justify-between items-center">
                    {/* text  */}
                    <h1 className=" text-xl text-pink-300 font-bold">All User</h1>
                </div>

                {/* table  */}
                <div className="w-full overflow-x-auto hide-scroll-bar">
                    <table className="w-full text-left border border-collapse sm:border-separate border-pink-100 text-pink-400 mb-12" >
                        <tbody>
                            <tr>
                                <th scope="col"
                                    className="h-12 px-6 text-md border-l first:border-l-0 border-pink-100 text-slate-700 bg-slate-100 font-bold fontPara">
                                    S.No.
                                </th>

                                <th scope="col"
                                    className="h-12 px-6 text-md border-l first:border-l-0 border-pink-100 text-slate-700 bg-slate-100 font-bold fontPara">
                                    Name
                                </th>

                                <th scope="col"
                                    className="h-12 px-6 text-md border-l first:border-l-0 border-pink-100 text-slate-700 bg-slate-100 font-bold fontPara">
                                    Email
                                </th>

                                <th scope="col"
                                    className="h-12 px-6 text-md border-l first:border-l-0 border-pink-100 text-slate-700 bg-slate-100 font-bold fontPara">
                                    Uid
                                </th>

                                <th scope="col"
                                    className="h-12 px-6 text-md border-l first:border-l-0 border-pink-100 text-slate-700 bg-slate-100 font-bold fontPara">
                                   Role
                                </th>

                                <th scope="col"
                                    className="h-12 px-6 text-md border-l first:border-l-0 border-pink-100 text-slate-700 bg-slate-100 font-bold fontPara">
                                    Date
                                </th>

                            </tr>
                            {
                                getAllUser.map((value, index) => {
                                    return (
                                      <tr key={index} className="text-pink-300">
                                        <td className="h-12 px-6 text-md transition duration-300 border-t border-l first:border-l-0 border-pink-100 stroke-slate-500 text-slate-500 ">
                                          {index + 1}
                                        </td>

                                        <td className="h-12 px-6 text-md transition duration-300 border-t border-l first:border-l-0 border-pink-100 stroke-slate-500 text-slate-500 first-letter:uppercase ">
                                          {value.name}
                                        </td>

                                        <td className="h-12 px-6 text-md transition duration-300 border-t border-l first:border-l-0 border-pink-100 stroke-slate-500 text-slate-500 cursor-pointer ">
                                          {value.email}
                                        </td>

                                        <td className="h-12 px-6 text-md transition duration-300 border-t border-l first:border-l-0 border-pink-100 stroke-slate-500 text-slate-500  cursor-pointer ">
                                          {value.uid}
                                        </td>

                                        <td className="h-12 px-6 border-t border-gray-200">
                                          <select
                                            value={value.role}
                                            onChange={(e) =>
                                              handleRoleChange(
                                                value.uid,
                                                e.target.value
                                              )
                                            }
                                            className="px-3 py-1 rounded-lg border border-gray-300 bg-white focus:ring-2 focus:ring-blue-500 transition"
                                          >
                                            <option value="user">User</option>
                                            <option value="admin">Admin</option>
                                          </select>
                                        </td>

                                        <td className="h-12 px-6 text-md transition duration-300 border-t border-l first:border-l-0 border-pink-100 stroke-slate-500 text-slate-500 cursor-pointer ">
                                          {value.date}
                                        </td>
                                      </tr>
                                    );
                                })
                            }

                        </tbody>
                    </table>
                </div>
            </div>
            <style dangerouslySetInnerHTML={{ __html: "\n.hide-scroll-bar {\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n}\n.hide-scroll-bar::-webkit-scrollbar {\n  display: none;\n}\n" }} />

        </div>
    );
}

export default UserDetails;
